export const engagementAppGroupIdPresetBannerTemplates = "/engagement/:app_group_id/preset_banner_templates";
